import * as React from 'react';
import { useMemo } from 'react';

import { IconName, useUiLabel } from '@canvas-logic/clp-shared-ui';
import { MenuListItem } from '@/ui-kit/components/MenuList/MenuListItem';
import { useGetPdf } from '@/ui-kit/hooks/use-get-pdf';

interface IProps {
  className?: string;
  label: string;
}

export const PdfDownloadMenuItem = ({ label, className }: IProps) => {
  const { state, generate } = useGetPdf();
  const downloadStartedToast = useUiLabel('ui.pdf.downloadStartedToast');

  const buttonIcon: IconName = useMemo(() => {
    switch (state) {
      case 'idle':
        return 'pdf';
      case 'ready':
        return 'check';
      case 'loading':
        return 'spinner';
    }
  }, [state]);

  return (
    <MenuListItem
      className={className}
      icon={buttonIcon}
      label={state === 'ready' ? downloadStartedToast : label}
      onClick={generate}
      loading={state === 'loading'}
    />
  );
};
